import React, { useState } from 'react';
import { Table, Select, Avatar, Icon } from 'udesk-ui';
import type { ColumnsType } from 'udesk-ui/lib/table';
import { useHistory } from 'react-router-dom';
import { IntelligentPartnerHomePageCourseRank } from 'src/api/types';
import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';

interface ScoreTableProps {
    loading?: boolean;
    data?: IntelligentPartnerHomePageCourseRank[];
    onChange?: (values: any) => void;
}

const ColorList = [
    'rgb(196, 161, 238)',
    'rgb(185, 204, 79)',
    'rgb(141, 200, 234)',
    'rgb(247, 156, 111)',
    'rgb(245, 177, 104)',
];

export const ScoreTable: React.FC<ScoreTableProps> = ({ loading = false, data = [], onChange }) => {
    const [scoreType, setScoreType] = useState<string | number | undefined>(
        Udesk.enums.coachScoreTypes.overallScore.id
    );
    const history = useHistory();

    const handleCourseClick = (record: IntelligentPartnerHomePageCourseRank) => {
        history.push({
            pathname: '/coach/course-evaluation/records',
            search: `?courseId=${record.courseId}&courseName=${record.courseName}`,
        });
    };

    const iconMap = {
        1: 'Frame16',
        2: 'a-Frame12',
        3: 'a-Frame21',
    };

    const columns: ColumnsType<IntelligentPartnerHomePageCourseRank> = [
        {
            title: /* 排名 */UdeskLocales['current'].pages.coach.courseEvaluation.overview.components.scoreTable.rankings,
            dataIndex: 'rank',
            width: 60,
            align: 'center',
            render(text, item) {
                return <Icon type={iconMap[text > 3 ? 3 : text]} style={{ fontSize: '24px' }} />;
            },
        },
        {
            title: '',
            dataIndex: 'avatar',
            width: 60,
            render(text, item) {
                return (
                    <Avatar
                        style={{
                            backgroundColor: ColorList[item.rank! % 4],
                            verticalAlign: 'middle',
                        }}
                        size={30}
                        gap={4}
                    >
                        {item.courseName}
                    </Avatar>
                );
            },
        },
        {
            title: /* 课程名称 */UdeskLocales['current'].pages.coach.courseEvaluation.overview.components.scoreTable.courseName,
            dataIndex: 'courseName',
            ellipsis: true,
            width: 100,
            render: (text, record) => <a onClick={() => handleCourseClick(record)}>{text}</a>,
        },
        {
            title: /* 评价数量 */UdeskLocales['current'].pages.coach.courseEvaluation.overview.components.scoreTable.evaluationQuantity,
            dataIndex: 'reviewTimes',
            align: 'right',
            width: 80,
        },
        {
            title: /* 练习人次 */UdeskLocales['current'].pages.coach.courseEvaluation.overview.components.scoreTable.practicePasses,
            dataIndex: 'practiceCount',
            align: 'right',
            width: 80,
        },
        {
            title: Udesk.enums.coachScoreTypes.get(scoreType).name,
            dataIndex: Udesk.enums.coachScoreTypes.get(scoreType).key,
            align: 'right',
            width: 80,
            defaultSortOrder: 'descend',
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) =>
                a[Udesk.enums.coachScoreTypes.get(scoreType).key] -
                b[Udesk.enums.coachScoreTypes.get(scoreType).key],
        },
    ];

    const changeScoreType = (value) => {
        setScoreType(value);
        onChange?.({
            listType: value,
            rank: [{ field: value, order: 1 }],
        });
    };

    const rankSortChange = (pagination, filters, sorter) => {
        console.log(sorter);
        onChange?.({
            listType: scoreType,
            rank: [{ field: 1, order: sorter.order === 'ascend' ? 2 : 1 }],
        });
    };

    return (
        <>
            <div className="table-header">
                <Select
                    value={scoreType}
                    onChange={(value) => changeScoreType(Number(value))}
                    style={{ width: 120 }}
                    options={Udesk.enums.coachScoreTypes.map((item) => ({
                        value: item.id,
                        label: item.name,
                    }))}
                />
            </div>
            <Table<IntelligentPartnerHomePageCourseRank>
                loading={loading}
                columns={columns}
                dataSource={data}
                onChange={rankSortChange}
                pagination={false}
                scroll={{ y: 350 }}
                size="small"
            />
        </>
    );
};
